import { FormTemplate } from "components/modal/templates";
import { serializeReq } from "components/shared/form";
import pick from "lodash/pick";
import React from "react";
import { editUser, getUserProfileForEdit } from "sources/admin";
import { config, initialState } from "./config";

class EditUser extends FormTemplate {
    componentDidMount() {
        getUserProfileForEdit(this.props.id).then((data) => {
            const stateData = pick(data, Object.keys(this.props.config));
            this.setState({ ...initialState, ...stateData, isLoading: false, isValid: true });
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { isLoading, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                return this.sendRequest(serializeReq(state, this.props.config)).then((res) => {
                    if (res) {
                        this.props.mergeParams && this.props.mergeParams();
                        this.close(res);
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    sendRequest = (stateData) => {
        if (stateData.phoneNumber === "+") {
            stateData.phoneNumber = "";
        }
        return editUser(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;
        return (
            <>
                {this.renderField(config.email)}
                {this.renderCheckbox(config.emailConfirmed)}
                {this.renderField(config.lastName)}
                {this.renderField(config.firstName)}
                {this.renderField(config.patronymic)}
                {this.renderField(config.phoneNumber)}
                {this.renderField(config.phoneNumberExtension)}
                {this.renderField(config.password)}
            </>
        );
    };
}

const ConfiguredModal = (props) => <EditUser {...props} config={config} initialState={initialState} />;

export default ConfiguredModal;
